import { getAggregateSavings } from '@/services/savings'
import { defineStore } from 'pinia'
import { reactive, computed } from 'vue'

export type SavingType =
  | 'BOOKING_WITH_POINTS'
  | 'MEMBER_RATE'
  | 'SUBSCRIPTION'
  | 'DIN'
  | 'SNU'
  | 'BURN_4STAY'

export interface Savings {
  valueInCurrency: number
  type: SavingType
  quantity?: number
}

interface TotalSavings {
  savings: Savings[]
  valueInCurrency: number
}

export interface YearSavings {
  year: number
  savings: Savings[]
  valueInCurrency: number
}

interface GetSavingsInterface {
  requestedCurrencyCode: string
  subscriptionSavings: {
    byCard: any[]
    total: TotalSavings
  }
  loyaltySavings: {
    byYear: YearSavings[]
    total: TotalSavings
  }
}
export interface ExperienceItem {
  id: string
  title: string
  url: string
  mainPictureUrl: string
  pricing: {
    startingPrice: number
    currency: string
    rewardPoints: number
  }
  rating: {
    rating: number
    outOf: number
  } | null
}

export interface ActivitiesData {
  booking: {
    hotel: {
      experiences: {
        paginationCursor: string
        items: Array<ExperienceItem>
      }
    }
  }
}

export const useSavingsStore = defineStore('savings', () => {
  const savings: GetSavingsInterface = reactive({
    requestedCurrencyCode: 'EUR',
    subscriptionSavings: {
      byCard: [],
      total: {
        savings: [
          {
            valueInCurrency: 0,
            type: 'SNU'
          }
        ],
        valueInCurrency: 0
      }
    },
    loyaltySavings: {
      byYear: [
        {
          year: 2023,
          savings: [
            {
              valueInCurrency: 0,
              type: 'SNU'
            }
          ],
          valueInCurrency: 0
        }
      ],
      total: {
        savings: [
          {
            valueInCurrency: 0,
            type: 'SNU'
          }
        ],
        valueInCurrency: 0
      }
    }
  })

  const loyaltySavingsTotal = computed(() => {
    return savings.loyaltySavings.total
  })

  const loyaltyReviewsTotal = computed(() => {
    return savings.subscriptionSavings.total
  })

  const loyaltySavingsByYear = computed(() => {
    return savings.loyaltySavings.byYear
  })

  const setSavings = (value: any) => {
    Object.assign(savings, value)
  }

  const getSavingsByYear = (savingYear: number) =>
    savings.loyaltySavings.byYear.find(({ year }) => year === savingYear)

  const loadSavings = async () => {
    try {
      const ordersData = await getAggregateSavings()
      setSavings(ordersData)
    } catch (err) {
      console.error(err)
    }
  }

  return {
    savings,
    loadSavings,
    setSavings,
    getSavingsByYear,
    loyaltySavingsTotal,
    loyaltyReviewsTotal,
    loyaltySavingsByYear
  }
})
